import { useState } from 'react';
import { Button } from '../../atoms/legacy/Button';
import { Select, SelectOption } from '../../atoms/legacy/Select';

type Cluster = {
  nomCluster: string;
  id: number;
};

export type ExportClusterUsersProps = {
  clusters: string;
};

/**
 * @deprecated This component was migrated from Preact and should not be used or refactored.
 * It does not comply with our current architectural patterns (compound components, proper separation of concerns, etc.).
 * These legacy components will be migrated in due course.
 */
export function ExportClusterUsers({ clusters }: ExportClusterUsersProps) {
  const parsedClusters: Cluster[] = JSON.parse(clusters);
  const normalizedClusters: SelectOption[] = Array.isArray(parsedClusters)
    ? parsedClusters.map((cluster) => ({
        label: cluster.nomCluster,
        value: cluster.id,
      }))
    : [];

  const [selectedCluster, setSelectedCluster] = useState(
    normalizedClusters[0]?.value?.toString() || '0',
  );

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    window
      .open(`/HektorBox/exportClusterUsers?cluster=${selectedCluster}`, '_blank')
      ?.focus();
  };

  return (
    <form className="flex flex-col gap-2" onSubmit={handleSubmit}>
      <Select
        label="Export des utilisateurs d'un cluster"
        options={[{ label: 'Tous les clusters', value: 0 }, ...normalizedClusters]}
        value={selectedCluster}
        setValue={setSelectedCluster}
      />

      <Button type="submit">Télécharger la liste des utilisateurs</Button>
    </form>
  );
}
